var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinnerLarge = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M30 8C17.85 8 8 17.85 8 30s9.85 22 22 22 22-9.85 22-22S42.15 8 30 8M0 30C0 13.432 13.432 0 30 0c16.569 0 30 13.432 30 30 0 16.569-13.431 30-30 30C13.432 60 0 46.569 0 30",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    fillRule: "evenodd",
    d: "M26 4a4 4 0 0 1 4-4c16.569 0 30 13.432 30 30a4 4 0 0 1-8 0c0-12.15-9.85-22-22-22a4 4 0 0 1-4-4",
    clipRule: "evenodd"
  })));
};
export default SvgSpinnerLarge;